// Piezas compartidas por las pantallas de finanzas de la plataforma.
// Viven aparte para que Gastos fijos y el resto de pestañas no dupliquen
// formatos ni listas, ni se importen entre sí.

export const METODOS = [
  'Transferencia', 'PSE', 'Tarjeta de crédito', 'Tarjeta débito',
  'Nequi', 'Daviplata', 'Efectivo', 'Otro',
];

// Cada cuánto se regenera un gasto fijo. '' = no se renueva.
export const PERIODICIDADES = [
  { valor: '',           label: 'No se renueva (único)' },
  { valor: 'semanal',    label: 'Semanal' },
  { valor: 'mensual',    label: 'Mensual' },
  { valor: 'trimestral', label: 'Trimestral' },
  { valor: 'semestral',  label: 'Semestral' },
  { valor: 'anual',      label: 'Anual' },
];

export const ETIQUETA_PERIODO = Object.fromEntries(
  PERIODICIDADES.filter(p => p.valor).map(p => [p.valor, p.label])
);

export const VERDE = '#22c55e';
export const ROJO  = '#ef4444';
export const AZUL  = '#3b82f6';
export const AMBAR = '#f59e0b';

export const money = (n) => '$' + Number(n || 0).toLocaleString('es-CO', { maximumFractionDigits: 0 });

export const hoy      = () => new Date().toISOString().slice(0, 10);
export const haceDias = (n) => new Date(Date.now() - n * 86400000).toISOString().slice(0, 10);
export const enDias   = (n) => new Date(Date.now() + n * 86400000).toISOString().slice(0, 10);

// Se arma desde el texto "2026-08-22" para que el huso del navegador no
// corra la fecha un día.
export const fmtFecha = (f) => {
  if (!f) return '';
  const d = new Date(String(f).slice(0, 10) + 'T00:00:00');
  return isNaN(d) ? f : d.toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const MESES_POR_PERIODO = { mensual: 1, trimestral: 3, semestral: 6, anual: 12 };
const dosDigitos = (n) => String(n).padStart(2, '0');

/**
 * Fecha de compra + un periodo = primer vencimiento.
 *
 * Lo que se compra el 18/06/2026 con renovacion anual vence el 18/06/2027, no
 * ese mismo dia. Los desbordes de mes se recortan igual que hace DATE_ADD en
 * MySQL, que es quien calcula las renovaciones siguientes: 31/01 + 1 mes da
 * 28/02, no un 31 de febrero que no existe.
 */
export const sumarPeriodo = (fechaISO, periodicidad) => {
  const m = String(fechaISO || '').slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m || !periodicidad) return fechaISO;

  const anio = Number(m[1]), mes = Number(m[2]), dia = Number(m[3]);

  if (periodicidad === 'semanal') {
    const d = new Date(Date.UTC(anio, mes - 1, dia + 7));
    return `${d.getUTCFullYear()}-${dosDigitos(d.getUTCMonth() + 1)}-${dosDigitos(d.getUTCDate())}`;
  }

  const meses = MESES_POR_PERIODO[periodicidad];
  if (!meses) return fechaISO;

  const corridos   = (mes - 1) + meses;
  const anioFinal  = anio + Math.floor(corridos / 12);
  const mesFinal   = (corridos % 12) + 1;
  const ultimoDia  = new Date(Date.UTC(anioFinal, mesFinal, 0)).getUTCDate();

  return `${anioFinal}-${dosDigitos(mesFinal)}-${dosDigitos(Math.min(dia, ultimoDia))}`;
};

const DIAS_SEMANA = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

// "Los 30 de cada mes", a partir de la periodicidad y una fecha de referencia.
// Es el mismo texto que arma el servidor en reglaRenovacion(); aqui sirve para
// enseñar la regla mientras se llena el formulario, antes de guardar.
export const reglaRenovacion = (periodicidad, fechaRef) => {
  if (!periodicidad) return 'No se renueva';
  const d = fechaRef ? new Date(String(fechaRef).slice(0, 10) + 'T00:00:00') : null;
  if (!d || isNaN(d)) return ETIQUETA_PERIODO[periodicidad] || periodicidad;

  const dia = d.getDate();
  const mes = d.toLocaleDateString('es-CO', { month: 'long' });
  switch (periodicidad) {
    case 'semanal':    return `Los ${DIAS_SEMANA[d.getDay()]} de cada semana`;
    case 'mensual':    return `Los ${dia} de cada mes`;
    case 'trimestral': return `El ${dia}, cada 3 meses`;
    case 'semestral':  return `El ${dia}, cada 6 meses`;
    case 'anual':      return `El ${dia} de ${mes}, cada año`;
    default:           return periodicidad;
  }
};

export const FORM_VACIO = {
  categoria_id: '', proveedor_id: '', descripcion: '', fecha: hoy(),
  monto: '', metodo_pago: '', notas: '', clase: 'variable', fecha_vencimiento: '',
  periodicidad: '', pagado: false,
};
